import { render, staticRenderFns } from "./McpClientGuide.vue?vue&type=template&id=888568a2&scoped=true&"
import script from "./McpClientGuide.vue?vue&type=script&lang=js&"
export * from "./McpClientGuide.vue?vue&type=script&lang=js&"
import style0 from "./McpClientGuide.vue?vue&type=style&index=0&id=888568a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888568a2",
  null
  
)

export default component.exports